import { useEffect, useState } from 'react';

import WaitIcon from 'assets/icons/sz/hourglass.svg';
import { SZ_CASH_URL } from 'constants/sz';
import { useLoadData } from 'hooks';
import { useAppSelector } from 'store/hooks';
import { ButtonKinds } from 'types/button';
import { costFormatWithCurrency } from 'utils/cost-format';
import { transformDateMoment } from 'utils/transform-date';
import { LoadingState } from 'views/shared/loading-state';

import { BaseCardSZ } from '../ui';
import { Button } from '../ui/button';

const maxCountRequests = 5;

const CheckWait = () => {
  const [countRequests, setCountRequests] = useState(0);
  const { paymentData, formKey, isPayment } = useAppSelector((state) => state.payment);
  const { loadData, isLoading } = useLoadData();

  useEffect(() => {
    const intervalHoldUpdate = setInterval(() => {
      if (countRequests < maxCountRequests) {
        loadData().then(() => {
          setCountRequests(countRequests + 1);
        });
      } else {
        clearInterval(intervalHoldUpdate);
      }
    }, 3 * 1000);

    return () => clearInterval(intervalHoldUpdate);
  }, [countRequests, loadData]);

  if (countRequests !== maxCountRequests) {
    return (
      <div className="w-full flex-grow items-center flex justify-center">
        <LoadingState formKey={formKey} />
      </div>
    );
  }

  return (
    <BaseCardSZ>
      <div className="flex flex-col justify-between">
        <div className="bg-white">
          <div className="p-4 md:p-6 text-center text-base leading-4 font-bold text-sz-black border-b border-b-sz-gray-400">
            <div className="flex items-center gap-[10px] leading-4 justify-center">
              <img src={WaitIcon} className="w-6 h-6" alt="success" />
              <span>{isPayment ? 'Ожидает платеж' : 'Ожидает выплаты'}</span>
            </div>
            <div className="text-sm font-medium mt-4">
              Для обновления статуса транзакции перезагрузите страницу
            </div>
          </div>
          <div className="p-4 md:p-6 text-base leading-4 font-medium text-sz-black border-b border-b-sz-gray-400 flex flex-col gap-6">
            <dl className="flex justify-between">
              <dt>Номер транзакции:</dt>
              <dd>{paymentData?.ID}</dd>
            </dl>
            <dl className="flex justify-between">
              <dt>{isPayment ? 'Дата платежа' : 'Дата выплаты'}:</dt>
              <dd>{paymentData?.date && transformDateMoment(paymentData?.date)}</dd>
            </dl>
            <dl className="flex justify-between">
              <dt>{isPayment ? 'Сумма платежа' : 'Сумма выплаты'}:</dt>
              <dd>
                {isPayment
                  ? costFormatWithCurrency(Number(paymentData?.amount))
                  : costFormatWithCurrency(
                      Math.abs(Number(paymentData?.fullAmount) || Number(paymentData?.amount)),
                    )}
              </dd>
            </dl>
            {isPayment && (
              <dl className="flex justify-between">
                <dt>Сумма к зачислению:</dt>
                <dd>{costFormatWithCurrency(Number(paymentData?.amount))}</dd>
              </dl>
            )}
          </div>
        </div>

        <div className="p-4 md:p-6 flex flex-col gap-3 mt-12 md:mt-0">
          <Button onClick={loadData} isLoading={isLoading}>
            Обновить
          </Button>
          <Button kind={ButtonKinds.secondary} href={SZ_CASH_URL}>
            В кошелек
          </Button>
        </div>
      </div>
    </BaseCardSZ>
  );
};

export { CheckWait };
